import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import { getPrice } from "core/includes/formatters";
import { taxLabelWithTaxable } from "core/includes/finance";
import useCart from "pages/Components/CartPage/hooks/useCart";

type Props = {
    quantity: number,
    discountPrice: number,
    isTaxable: boolean,
    totalPrice: number
};

const CartItemQuantityAndPrice: React.FC<Props> = ({ quantity, totalPrice, isTaxable, discountPrice }) => {
    const theme: Theme = useTheme();
    const { getCountry } = useCart();
    const countryCode = getCountry();
    const wasDiscounted = discountPrice > 0;
    const discountedPrice = totalPrice - discountPrice;

    const style = css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 6px;
        height: 100%;
        max-height: 67px;
        white-space: nowrap;
        text-align: right;
        color: ${theme.colours.shipGray};

        ${theme.breakpoints.between("md", "xl")} {
            margin-left: 5px;
        }

        ${theme.breakpoints.between("sm", "lg")} {
            margin-left: 3px;
        }

        ${theme.breakpoints.down("xs")} {
            margin-left: 2px;
        }
    `;

    const quantityStyle = css`
        font-weight: ${theme.fonts.weights.bold};
    `;

    const gstStyle = css`
        font-size: 8px;
        line-height: 5px;
    `;

    const slashedPriceStyle = css`
        font-weight: ${theme.fonts.weights.light};
        text-decoration: line-through ${theme.colours.red1};
    `;

    return (
        <div css={style}>
            <div css={quantityStyle}>(Qty : {quantity})</div>
            <div>
                {wasDiscounted && (
                    <p css={slashedPriceStyle}>
                        {countryCode.currency}{getPrice(totalPrice)}
                    </p>
                )}
                <p>
                    {countryCode.currency}{getPrice(wasDiscounted ? discountedPrice : totalPrice)}
                </p>
                <p css={gstStyle}>({taxLabelWithTaxable(isTaxable, countryCode.taxLabel)})</p>
            </div>
        </div>
    );
};

export default CartItemQuantityAndPrice;